import React, { useEffect, useState } from "react";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import {Card, CardBody,Modal,ModalHeader,Button,Label,Input} from "reactstrap";
import 'bootstrap/dist/css/bootstrap.min.css';
import Form from 'react-bootstrap/Form';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Table from 'react-bootstrap/Table';
import {ToastContainer,toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { v4 as uuidv4 } from 'uuid';
import Axios from 'axios'
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';
import 'jspdf-autotable';

export default function Claims() {
    const [agent, setAgent] = useState('')
    const [agentCode, setAgentcode] = useState('')
    const [extensions, setExtensions] = useState([])
    const [walletNo, setWalletno] = useState('')
    const [currentPage, setCurrentPage] = useState(1);
    const rowsPerPage = 20;
    const totalPages = Math.ceil(extensions.length / rowsPerPage);
    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;
    const currentPolicies = extensions.slice(indexOfFirstRow, indexOfLastRow)
    const [modal, setModal] = useState(false)
    const [policies, setPolicies] = useState([])
    const [policyNumber, setPolicynumber] = useState('')
    const [client, setClient] = useState('')
    const [clients, setClients] = useState([])
    const [nature, setNature] = useState([])
    const [natureOfloss, setNatureofloss] = useState('')
    const [searchTerm, setSearchTerm] = useState('');
    const [suggestions, setSuggestions] = useState([]);
    const [selectedClient, setSelectedClient] = useState(null);
    const [proposals, setProposals] = useState([])
    const [dateOfloss, setDateofloss] = useState(null)
    const [claimAmount, setClaimamount] = useState(0)
    const [today, setToday] = useState(null)
    const [submitText, setSubmittext] = useState('SUBMIT')
    const [allClaims, setAllclaims] = useState([])
    const [claimNumber, setClaimnumber] = useState('')
    const [credentials, setCredentials] = useState(null)
    const [isAuth, setIsauth] = useState(false)
    const company = 'Definite'

    useEffect(()=>{
    const getCredentials =async()=>{
    const res = await fetch(`https://digitalapi.definiteassurance.com/api/getCredentials?username=${company}`)
    const data = await res.json();
    const {Username, Password} = data;
    const cred = btoa(`${Username}:${Password}`)
    setCredentials(btoa(`${Username}:${Password}`))
    setIsauth(true)


    }
    getCredentials()

    },[])

    useEffect(()=>{
    const now = new Date();
    
    // Format YYYY-MM-DD
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    
    // Format HH:mm:ss.SSS
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');
    const milliseconds = String(now.getMilliseconds()).padStart(3, '0');
    
    

    setToday(`${year}-${month}-${day} ${hours}:${minutes}:${seconds}.${milliseconds}`)

    },[])

    const handleDateChange = (e) => {
        const dateTime = e.target.value;
        const millisecondsSinceEpoch = new Date(dateTime).getTime();
        setDateofloss(formatDate(millisecondsSinceEpoch))
    
    }

    function formatDate(milliseconds) {
        const date = new Date(milliseconds);
        
        // Extract date components
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');
        const ms = String(date.getMilliseconds()).padStart(3, '0');
        
        // Format as YYYY-MM-DD HH:mm:ss.ms
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}.${ms}`;
    }




    const handleSelect = (client) => {
        setSearchTerm(`${client.FirstName} ${client.Surname}`);
        setSelectedClient(client.OID);
        setSuggestions([]);
      };
    
    const handleSearch = (e) => {
    const value = e.target.value;
    setSearchTerm(value);

    if (value.length > 0) {
        const filtered = clients.filter(
        (client) =>
            client.FirstName.toLowerCase().includes(value.toLowerCase()) ||
            client.Surname.toLowerCase().includes(value.toLowerCase()) ||
            client.IdentificationNo.toLowerCase().includes(value.toLowerCase())
        );
        setSuggestions(filtered);
    } else {
        setSuggestions([]);
    }
    };



    const toggle =()=>{
        setModal(!modal)
    }

    useEffect(() => {
          
        const user = localStorage.getItem('definiteagent'); // Retrieve email
        if (user) {
            
            setAgent(user)
        } else {
    
        }
        }, []);

        useEffect(()=>{

           const getData = async()=>{
            const res = await fetch(`https://digitalapi.definiteassurance.com/api/getNatureofloss`,{
                 method:"GET",
                headers:{
                  'Authorization': `Basic ${credentials}`,
                  'Content-Type': "application/json"
                }
            })
            const data = await res.json();
            setNature(data)
           }

           const getAllclaims = async()=>{
            const res = await fetch(`https://digitalapi.definiteassurance.com/api/getAllclaims`,{
                 method:"GET",
                headers:{
                  'Authorization': `Basic ${credentials}`,
                  'Content-Type': "application/json"
                }
            })
            const data = await res.json();
            const cn = `ICN2025/000${data.length + 1}`;
            setClaimnumber(cn)
            setAllclaims(data)
           }
            if(isAuth){
                getData()
                getAllclaims()
            }


        },[isAuth])
    
        useEffect(()=>{
            const getAgentcode =async()=>{
                const res =await fetch(`https://digitalapi.definiteassurance.com/api/getDealerdetails?email=${agent}`,{
                     method:"GET",
                headers:{
                  'Authorization': `Basic ${credentials}`,
                  'Content-Type': "application/json"
                }
                });
                const data = await res.json();
                setAgentcode(data.OID)   
    
            }
            if(agent && isAuth){
                getAgentcode()
            }
        },[agent,isAuth])
    
        useEffect(()=>{
           
    
        const getMyclaims =async()=>{
            const res = await fetch(`https://digitalapi.definiteassurance.com/api/getMyclaims?agent=${agentCode}`,{
                 method:"GET",
                headers:{
                  'Authorization': `Basic ${credentials}`,
                  'Content-Type': "application/json"
                }
            })
            const data = await res.json();
            setExtensions(data)

        }

        const getCustomers =async()=>{
            const res = await fetch(`https://digitalapi.definiteassurance.com/api/getClients?agent=${agentCode}`,{
                 method:"GET",
                headers:{
                  'Authorization': `Basic ${credentials}`,
                  'Content-Type': "application/json"
                }
            });
            const data = await res.json();
            setClients(data)
        }

        if(agentCode && isAuth){
            getCustomers()
            getMyclaims()
        }
    
        },[agentCode,isAuth])

        const getMyclaims =async()=>{
            const res = await fetch(`https://digitalapi.definiteassurance.com/api/getMyclaims?agent=${agentCode}`,{
                 method:"GET",
                headers:{
                  'Authorization': `Basic ${credentials}`,
                  'Content-Type': "application/json"
                }
            })
            const data = await res.json();
            setExtensions(data)

        }



        useEffect(()=>{

            const getProposals = async()=>{
                const res = await fetch(`https://digitalapi.definiteassurance.com/api/getClientpolicies?client=${selectedClient}`,{
                     method:"GET",
                headers:{
                  'Authorization': `Basic ${credentials}`,
                  'Content-Type': "application/json"
                }
                })
                const data = await res.json();
                setProposals(data)
            }

            if(selectedClient && isAuth){
                getProposals()
            }

        },[selectedClient,isAuth])



  const submitClaim =async()=>{

    setSubmittext('Please wait....')
    const res = await fetch(`https://digitalapi.definiteassurance.com/api/postClaim`,{
        method:"POST",
                headers:{
                  'Authorization': `Basic ${credentials}`,
                  'Content-Type': "application/json"
                },
        body:JSON.stringify({policyNumber,dateOfloss,natureOfloss,claimAmount,today,claimNumber,selectedClient,agentCode}),
        credentials:"include"
    })

    const data = await res.json();
    const {success} = data;

    if(success){
        setSubmittext('SUBMIT')
        toast.success('Claim submitted successfully')
        getMyclaims()
        setModal(false)
    }
    else{
        setSubmittext('SUBMIT')
        toast.error('SOMETHING WENT WRONG')
    }

  }

  function formateDateISO(input){
    if(typeof input === 'string'){
        return input.split('T')[0]
    }
    else if (input instanceof Date){
        return input.toISOString().split('T')[0]
    }

    throw new Error('Invalid input: Expected ISO String or Date Object')
}

function formatter(amount) {
    return amount.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
  }
  return (
    <div>
        <div className="page-content">
        <ToastContainer />
        <Breadcrumbs title="Definite Assurance" breadcrumbItem={`MY CLAIMS`} />
        <Card className="mini-stats-wid">
            <CardBody>
                <Button color="success" onClick={toggle}>+ New Claim</Button>
                
                <hr />
               
                    <div className="table-responsive" style={{padding:'10px'}}>


                <Table striped bordered hover id="policy-table">
                <thead>
                    <tr>
                    <th scope="col">#</th>
                    <th scope="col">Client</th>
                    <th scope="col">Policy No.</th>
                    <th scope="col">Date of loss</th>     
                    <th scope="col">Nature of Loss</th>
                    <th scope="col">Claim Amount</th>
                    <th scope="col">Status</th>
                    </tr>
                </thead>
                <tbody>
                    {currentPolicies.map((val, index) => {
                    // Calculate the correct index based on current page
                    const globalIndex = indexOfFirstRow + index;
                    const transactionDate = new Intl.DateTimeFormat('en-US',{month:'2-digit',day:'2-digit', year:'numeric'}).format(val.DateDone)
                            return (
                                <tr key={val.OID}>
                                <td>{index+1}</td>
                                <td>{val.Dealer_name}</td>
                                <td>{val.ProposalNo}</td>
                                <td>{formateDateISO(val.DateOfLoss)}</td>
                                <td>{val.NatureOfClaimsDescriptions}</td>
                                <td>KES. {formatter(val.ClaimAmount)}</td>
                                <td>{val.ClaimPositionDescription}</td>
                                </tr>
                            );

                    })}
                </tbody>
                </Table>

                {/* Pagination controls */}
                <div className="d-flex justify-content-between align-items-center">
                <div>
                    Showing {indexOfFirstRow + 1} to {Math.min(indexOfLastRow, extensions.length)} of {extensions.length} entries
                </div>
                <div>
                    <button 
                    className="btn btn-sm btn-outline-primary mx-1"
                    onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                    disabled={currentPage === 1}
                    >
                    Previous
                    </button>
                    
                    {Array.from({ length: totalPages }, (_, i) => i + 1).map(page => (
                    <button
                        key={page}
                        className={`btn btn-sm mx-1 ${currentPage === page ? 'btn-primary' : 'btn-outline-primary'}`}
                        onClick={() => setCurrentPage(page)}
                    >
                        {page}
                    </button>
                    ))}
                    
                    <button 
                    className="btn btn-sm btn-outline-primary mx-1"
                    onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                    disabled={currentPage === totalPages}
                    >
                    Next
                    </button>
                </div>
                </div>
                </div>
                
            </CardBody>
        </Card>
        </div>

        <Modal isOpen={modal} toggle={toggle} size="lg">
            <ModalHeader>New claim</ModalHeader>
            <div className="modalContainer">
            
            <FloatingLabel className='formInput2' controlId="floatingInputGrid" label="SEARCH CLIENT NAME OR ID NUMBER" onChange={handleSearch}>
            <Form.Control  className='inputSearch' value={searchTerm}  type="text" placeholder="Search by First or Last Name" />
            {suggestions.length > 0 && (
                <ul
                style={{
                    position: 'absolute',
                    top: '100%',
                    left: 0,
                    right: 0,
                    zIndex: 1000,
                    listStyle: 'none',
                    padding: 0,
                    margin: 0,
                    backgroundColor: 'white',
                    border: '1px solid #ccc',
                    maxHeight: '200px',
                    overflowY: 'auto',
                }}
                >
                {suggestions.map((client) => (
                    <li
                    key={client.OID}
                    onClick={() => handleSelect(client)}
                    style={{
                        padding: '8px',
                        cursor: 'pointer',
                        borderBottom: '1px solid #eee',
                    }}
                    onMouseEnter={(e) => {
                        e.target.style.backgroundColor = '#f0f0f0';
                    }}
                    onMouseLeave={(e) => {
                        e.target.style.backgroundColor = 'white';
                    }}
                    >
                    {client.FirstName} {client.Surname} {client.IdentificationNo}
                    </li>
                ))}
                </ul>
            )}
        </FloatingLabel>

        <FloatingLabel className='formInput2' controlId="floatingInputGrid" label="Select Policy*" onChange={(e)=>{setPolicynumber(e.target.value)}}>
            <Form.Select className='inputSearch'>
                <option selected disabled>SELECT POLICY</option>
                {proposals.map((val)=>{
                    return(
                        <option key={val.OID} value={val.OID}>{val.Narration} - {val.PolicyNo}</option>
                    )
                })}
            </Form.Select>
            
        </FloatingLabel>

        <FloatingLabel className='formInput2' controlId="floatingInputGrid" label="Nature of loss*" onChange={(e)=>{setNatureofloss(e.target.value)}}>
            <Form.Select className='inputSearch'>
                <option selected disabled>SELECT NATURE OF LOSS</option>
                {nature.map((val)=>{
                    return(
                        <option key={val.OID} value={val.OID}>{val.NatureOfClaimsDescriptions}</option>
                    )
                })}
            </Form.Select>
            
        </FloatingLabel>

        <FloatingLabel className='formInput2' controlId="floatingInputGrid" label="Date of loss*" onChange={handleDateChange}>
            <Form.Control  className='inputSearch'   type="datetime-local" placeholder="Date of loss" />
        </FloatingLabel>

        <FloatingLabel className='formInput2' controlId="floatingInputGrid" label="Claim Amount*" onChange={(e)=>{setClaimamount(e.target.value)}}>
            <Form.Control  className='inputSearch'   type="number" placeholder="Claim Amount*" />
        </FloatingLabel>
        <div className="">
            <Button color="success" onClick={submitClaim}>{submitText}</Button>
        </div>
            </div>

        </Modal>
        
    </div>
  )
}
